import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { FlexBetween } from "../../../styles/styled-components-utils";
// import { Panel, PanelContainer } from './AddGoogleIDs';

export const PanelContainer = styled(FlexBetween)`
  flex-wrap: wrap;
  border-bottom: 2px solid black;
`;

export const Panel = styled.div`
  display: flex;
  margin: 10px;
`;
const AuthorizedComponent = ({ dataFunction, renderFunction }) => {
  const [componentState, setComponentState] = useState({
    data: [],
    loading: true,
  });

  useEffect(function fetchDataWhenFunctionChanges() {
    async function getData() {
      try {
        setComponentState({ data: [], loading: true, errors: undefined });
        const data = await dataFunction();
        console.log(data);
        setComponentState({ data, loading: false });
      } catch (errors) {
        console.log(errors);
        setComponentState({ data: [], loading: false, errors });
      }
    }
    getData();
  }, [dataFunction]);

  if (componentState.loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" aria-label="Loading"></div>
        <div className="loading-text">Loading...</div>
      </div>
    );
  }

  return componentState.errors === undefined
    ? renderFunction(componentState.data)
    : `${componentState.errors.errors[0].msg}`;
};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(AuthorizedComponent);
